import whyAlexandriaCoffee from './editorial/why-alexandria-coffee.json';
import cornicheHistory from './editorial/corniche-history.json';
import fishMarketAnfoushi from './editorial/fish-market-anfoushi.json';
import lostCinemas from './editorial/lost-cinemas.json';
import winterStormsNawat from './editorial/winter-storms-nawat.json';
import tramRoute1860 from './editorial/tram-route-1860.json';
import greekHeritageAlexandria from './editorial/greek-heritage-alexandria.json';
import winterFoodAlex from './editorial/winter-food-alex.json';
import villasOfSmouha from './editorial/villas-of-smouha.json';
import seaSportsAlex from './editorial/sea-sports-alex.json';

export const EDITORIAL_POSTS = [
whyAlexandriaCoffee,
cornicheHistory,
fishMarketAnfoushi,
lostCinemas,
winterStormsNawat,
tramRoute1860,
greekHeritageAlexandria,
winterFoodAlex,
villasOfSmouha,
seaSportsAlex];